/* F-59: voetkolommen klappen op de telefoon open en dicht (zoals de oorspronkelijke winkel). Op de computer blijft alles open.
   Eigen code, geen onderdeel van Horizon. Koppen krijgen role=button, toetsenbord (Enter, spatie) en aria-expanded. */
(function () {
  var smal = window.matchMedia('(max-width: 749px)');

  function zet(groep, kop, open) {
    groep.setAttribute('data-bri-open', open ? '1' : '0');
    kop.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function start() {
    var groepen = document.querySelectorAll('.footer-content > .group-block');
    groepen.forEach(function (groep) {
      var kop = groep.querySelector('h2');
      if (!kop || kop.getAttribute('data-bri-acc')) return;
      kop.setAttribute('data-bri-acc', '1');
      kop.setAttribute('role', 'button');
      kop.setAttribute('tabindex', '0');
      zet(groep, kop, false);
      var wissel = function () {
        if (!smal.matches) return;
        zet(groep, kop, groep.getAttribute('data-bri-open') !== '1');
      };
      kop.addEventListener('click', wissel);
      kop.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          wissel();
        }
      });
    });
  }

  /* het script is "defer": de pagina is dan al opgebouwd; start() is veilig om vaker te draaien */
  document.addEventListener('DOMContentLoaded', start);
  window.addEventListener('load', start);
  document.addEventListener('shopify:section:load', start);
})();
